import {differenceInDays, parseISO} from 'date-fns';
import {TFunction} from 'i18next';

export const getGroupInvitationExpiryTime = (t: TFunction, expiryDateTime: string, now = new Date()) => {
  const dayDifference = differenceInDays(parseISO(expiryDateTime), now);
  return dayDifference > 0 ? t('workplace:DayToRespond', {count: dayDifference}) : t('workplace:FinalDayToRespond');
};
